import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ClI18nConfig, ClLabels } from '@corelabs/angular/ui';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

const LABEL_KEYS: Record<keyof ClLabels, string> = {
    chooseDate: marker('cl.ui.choose-date'),
    clearDate: marker('cl.ui.clear-date'),
    clearSelection: marker('cl.ui.clear-selection'),
    invalidDate: marker('cl.ui.invalid-date'),
    previousMonth: marker('cl.ui.previous-month'),
    nextMonth: marker('cl.ui.next-month'),
    month: marker('cl.ui.month'),
    year: marker('cl.ui.year'),
    closeDialog: marker('cl.ui.close-dialog'),
    closeMessage: marker('cl.ui.close-message'),
    loading: marker('cl.ui.loading'),
    severityDanger: marker('cl.ui.severity-danger'),
    severityWarn: marker('cl.ui.severity-warn'),
    severitySuccess: marker('cl.ui.severity-success'),
    severityInfo: marker('cl.ui.severity-info'),
    pagination: marker('cl.ui.pagination'),
    firstPage: marker('cl.ui.first-page'),
    previousPage: marker('cl.ui.previous-page'),
    nextPage: marker('cl.ui.next-page'),
    lastPage: marker('cl.ui.last-page'),
    rowsPerPage: marker('cl.ui.rows-per-page'),
    showPassword: marker('cl.ui.show-password'),
    hidePassword: marker('cl.ui.hide-password'),
};

/** `provideClI18n(clI18nConfig)` - the `cl-*` components' built-in labels, translated and following a language switch. */
export function clI18nConfig(): Signal<ClI18nConfig> {
    const translateService = inject(TranslateService);
    const labels$ = translateService.stream(Object.values(LABEL_KEYS)).pipe(
        map((translations: Record<string, string>): ClI18nConfig => {
            const entries = Object.entries(LABEL_KEYS).map(([name, key]) => [name, translations[key]]);

            return { locale: translateService.getCurrentLang() ?? undefined, labels: <Partial<ClLabels>>Object.fromEntries(entries) };
        }),
    );

    return toSignal(labels$, { initialValue: <ClI18nConfig>{} });
}
